module.exports = __webpack_public_path__ + "images/videoCaseStudy-icon-graph-pie.svg?h=e18f0ee5913bcec1c1614960a5f0f441";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/videoCaseStudy-icon-graph-pie.svg
// module id = 1719
// module chunks = 12 15